import React       from 'react';
import HiddenInput from './HiddenInput';

const ProductQuoteNumber = ({ parameters, groupName }) => {
  const name = 'product_quote_number';
  return (
    <HiddenInput
      name={name}
      value={parameters[name] || ''}
      groupName={groupName} />
  );
};

ProductQuoteNumber.defaultProps = {
};

export default ProductQuoteNumber;
